import { useState, useEffect, useCallback } from 'react';

const DEFAULT_DURATION = 3000;

export function useAlert(duration = DEFAULT_DURATION) {
  const [alert, setAlert] = useState<{ message: string; type: 'success' | 'error'; isVisible: boolean }>({
    message: '',
    type: 'success',
    isVisible: false,
  });

  useEffect(() => {
    if (alert.isVisible) {
      const timer = setTimeout(() => setAlert((prev) => ({ ...prev, isVisible: false })), duration);
      return () => clearTimeout(timer);
    }
  }, [alert.isVisible, duration]);

  const showAlert = useCallback((message: string, type: 'success' | 'error') => {
    setAlert({ message, type, isVisible: true });
  }, []);

  const hideAlert = useCallback(() => {
    setAlert((prev) => ({ ...prev, isVisible: false }));
  }, []);

  return { alert, showAlert, hideAlert };
}
